export const T = {
  en_GB: {
    product: "Product",
    isin: "ISIN",
    addProduct: "Add Product",
    editProductWeight: "Edit Product Weight",
    addProductToPortfolio: "Add Product to Portfolio",
    editDescription: "Update the weight allocation for this product.",
    addDescription: "Select a product from your register and set its weight allocation.",
    selectProduct: "Select a product",
    searchProducts: "Search by name or ISIN…",
    noProductsAvailable: "No products available. All products have been added or none exist.",
    noProductsMatch: "No products match your search.",
    weightPercent: "Weight (%)",
    weightPlaceholder: "e.g., 25.5",
    currentTotal: "Current total:",
    remaining: "Remaining:",
    cancel: "Cancel",
    save: "Save",
    selectProductAndWeight: "Please select a product and enter weight",
    weightBetween0And100: "Weight must be between 0 and 100",
    failedToAddProduct: "Failed to add product",
    weightRequired: "Weight is required",
    failedToUpdateWeight: "Failed to update weight",
  },
  nb_NO: {
    product: "Produkt",
    isin: "ISIN",
    addProduct: "Legg til produkt",
    editProductWeight: "Rediger produktvekting",
    addProductToPortfolio: "Legg til produkt i portefølje",
    editDescription: "Oppdater vektingsallokeringen for dette produktet.",
    addDescription: "Velg et produkt fra registeret ditt og sett vektingsallokeringen.",
    selectProduct: "Velg et produkt",
    searchProducts: "Søk etter navn eller ISIN…",
    noProductsAvailable:
      "Ingen produkter tilgjengelig. Alle produkter er lagt til eller ingen finnes.",
    noProductsMatch: "Ingen produkter samsvarer med søket ditt.",
    weightPercent: "Vekting (%)",
    weightPlaceholder: "f.eks. 25,5",
    currentTotal: "Nåværende totalt:",
    remaining: "Gjenstående:",
    cancel: "Avbryt",
    save: "Lagre",
    selectProductAndWeight: "Vennligst velg et produkt og angi vekting",
    weightBetween0And100: "Vekting må være mellom 0 og 100",
    failedToAddProduct: "Kunne ikke legge til produkt",
    weightRequired: "Vekting er påkrevd",
    failedToUpdateWeight: "Kunne ikke oppdatere vekting",
  },
} as const;
